import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CloseButton,
  Container,
  Modal,
  ModalContent,
  Wrapper,
} from "../style/view.styles";
import { Sidebar, SidebarContainer } from "../style/sidebar.styles";
import BackButton from "../components/Buttons/BackButton";
import { getLoggedInUser } from "../utils/AuthHandler";
import MentorshipApplicationForm from "../components/Elements/MentorshipApplicationForm";
import MentorDetailsBody from "../components/Elements/MentorDetailsBody";

export default function MentorDetails() {
  const location = useLocation();

  const mentor = location.state?.mentor || null;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const handleApplyModalClose = () => setIsApplyModalOpen(false);
  const handleCancelModalClose = () => setIsCancelModalOpen(false);
  const [isConnectionSent, setIsConnectionSent] = useState(false);

  useEffect(() => {
    const user = getLoggedInUser();
    setIsLoggedIn(!!user);
    setUser(user);
  }, []);

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleApplyModalClose();
    }
  };

  if (!mentor) {
    return (
      <>
        <Wrapper className="paleBlueGreyBg">
          <div className="container">
            <p className="font18">Mentor details not available.</p>
          </div>
        </Wrapper>
      </>
    );
  }

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <SidebarContainer>
            <Sidebar>
              <BackButton path="/mentors" />
            </Sidebar>
          </SidebarContainer>
          <MentorDetailsBody
            mentor={mentor}
            user={user}
            isApplyModalOpen={isApplyModalOpen}
            setIsApplyModalOpen={setIsApplyModalOpen}
            isLoggedIn={isLoggedIn}
            isConnectionSent={isConnectionSent}
          />
        </Container>
      </Wrapper>
      {isApplyModalOpen && (
        <Modal onClick={handleModalBackgroundClick}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={handleApplyModalClose}>X</CloseButton>
            <MentorshipApplicationForm
              selectedMentor={mentor}
              handleModalClose={handleApplyModalClose}
              setIsConnectionSent={setIsConnectionSent}
            />
          </ModalContent>
        </Modal>
      )}
      {isCancelModalOpen && (
        <Modal
          selectedMentor={mentor}
          handleModalClose={handleCancelModalClose}
        />
      )}
    </>
  );
}
